import ProductRecipeTab from './ProductRecipeTab';
export default ProductRecipeTab;
